import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { AppProvider } from "./app/provider.jsx";
import { Toaster } from "react-hot-toast";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AppProvider>
      {" "}
      <App />
      <Toaster
        position="top-center"
        containerStyle={{
          top: "60px",
        }}
        toastOptions={{
          style: {
            fontSize: "14px",
            border: "1px solid #E7E8EB",
            borderRadius: "4px",
            fontWeight: 500,
            overflow: "hidden",
            background: "#0F172A",
            color: "#fff",
            paddingInline: "20px",
          },
        }}
      />
    </AppProvider>
  </StrictMode>
);
